import type { ClassValue } from 'clsx'

import { clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * The class merger, taught the design system's own scales. Without this it
 * reads text-small or text-h4 as a colour, so a size and a colour on the same
 * element cancel each other out and the size is silently dropped.
 * Keep these lists in step with the type scale and motion utilities in globals.css.
 */
const twMerge = extendTailwindMerge({
    extend: {
        theme: {
            text: ['micro', 'caption', 'small', 'body', 'body-lg', 'lead', 'h4', 'h3', 'h2', 'h1', 'display']
        },
        classGroups: {
            duration: [{ duration: ['fast', 'base', 'slow'] }]
        }
    }
})

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}
